import { AuthToken } from '~/types/AuthToken.interface'
import { RestAPI } from './core'

const users = {
  authTokens: new RestAPI<AuthToken>('/api/users/auth-tokens', 'Auth token'),
}

export { users }
